// ════════════════════════════════════════════════════════════════════════════
//  Udisys Gestor Web  —  src/features/apikeys/apiKeysService.ts
//  Chaves de API longa-vivas (X-API-Key) — conectar Claude Desktop/integrações
//  sem renovar o token de 24h. A chave em claro só vem uma vez, na criação.
// ════════════════════════════════════════════════════════════════════════════

import { apiClient } from '@/lib/apiClient';

const BASE = '/api/apikeys';

/** Chave listada (nunca traz o segredo). */
export interface ApiKeyResumo {
  id: number;
  nome: string;
  prefixo: string;
  ativo: boolean;
  criadoEm: string;
  ultimoUsoEm: string | null;
  expiraEm: string | null;
}

/** Retorno da criação — `chave` é o segredo em claro, exibido uma única vez. */
export interface ApiKeyCriada {
  id: number;
  nome: string;
  chave: string;
  prefixo: string;
  expiraEm: string | null;
  aviso: string;
}

export const apiKeysService = {
  async listar(): Promise<ApiKeyResumo[]> {
    const { data } = await apiClient.get<ApiKeyResumo[]>(BASE);
    return data;
  },

  async criar(nome: string, expiraEmDias?: number | null): Promise<ApiKeyCriada> {
    const { data } = await apiClient.post<ApiKeyCriada>(BASE, {
      nome,
      expiraEmDias: expiraEmDias && expiraEmDias > 0 ? expiraEmDias : null,
    });
    return data;
  },

  async revogar(id: number): Promise<void> {
    await apiClient.delete(`${BASE}/${id}`);
  },
};
